'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _publish = require('../../redux/modules/normalizers/publish');
var _clearNumber = require('../../helpers/clearNumber');var _clearNumber2 = _interopRequireDefault(_clearNumber);
var _constants = require('../../constants');
var _components = require('../../components');

var _MortgageCalculate = require('./MortgageCalculate.scss');var _MortgageCalculate2 = _interopRequireDefault(_MortgageCalculate);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Helper
// Style
var periodInYearsDefault = 25;var
MortgageCalculate = function (_Component) {_inherits(MortgageCalculate, _Component);
  function MortgageCalculate(props) {_classCallCheck(this, MortgageCalculate);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_this.
















    onKeyDown = function (event) {
      if (event.keyCode === _constants.enterKey) {
        _this.calculateMortgage();
      }
    };_this.

    onChangeApartment = function (_ref) {var target = _ref.target;
      var value = (0, _clearNumber2.default)(target.value);
      if (value && value.length <= 17) {
        _this.setState({
          changeEquity: false,
          priceApartment: Math.round(value),
          equity: Math.round(value / 7) });

      }
    };_this.

    onChangePeriodInYears = function (_ref2) {var target = _ref2.target;
      _this.setState({
        periodInYears: Math.round((0, _clearNumber2.default)(target.value) || 0) });

    };_this.

    onChangeRate = function (_ref3) {var target = _ref3.target;
      var value = _this.clearRate(target.value);

      _this.setState({
        rate: value > 100 ? 100 : value });

    };_this.

    onChangeEquity = function (_ref4) {var target = _ref4.target;
      var value = (0, _clearNumber2.default)(target.value);
      if (value <= _this.state.priceApartment) {
        _this.setState({
          changeEquity: true,
          equity: Math.round(value || 0) });

      }
    };_this.

    setValueByDefault = function (value) {
      if (!value) {
        _this.setState({
          priceApartment: _this.props.price,
          equity: Math.round(_this.props.price / 7),
          periodInYears: periodInYearsDefault },
        function () {return _this.calculateMortgage();});
      }
    };_this.

    clearRate = function (value) {return value.toString().
      replace(/,/g, '.').
      replace(/[^\d,\\.]/g, '').
      replace(/\./, '___').
      replace(/\./g, '').
      replace(/___/, '.');};_this.


    calculateMortgage = function () {var _this$state =
      _this.state,equity = _this$state.equity,periodInYears = _this$state.periodInYears,rate = _this$state.rate;
      if (!equity && equity !== 0 || !periodInYears && periodInYears !== 0) {
        return _this.setValueByDefault(false);
      }
      var interestRateForMonth = +rate / 100 / 12;
      var yearsToMonths = periodInYears * 12;
      var mortgage = _this.state.changeEquity ? _this.props.price - equity : equity * 2;
      var iRFM = Math.pow(1 + interestRateForMonth, yearsToMonths);

      var mortgageResult = !!+rate ? mortgage * (interestRateForMonth * iRFM / (iRFM - 1)) : mortgage / yearsToMonths;
      return _this.setState({
        mortgage: Math.round(mortgage),
        monthlyRepayRepresents: Math.round(mortgageResult) });

    };_this.

    positionIcon = function (value) {var _this$props =
      _this.props,isMobile = _this$props.isMobile,isRtl = _this$props.isRtl;
      if (!global.document) {
        return { left: isRtl ? 0 : '133px' };
      }
      var input = document.querySelector('.' + _MortgageCalculate2.default.mortgageCalculateInput + ' input');
      var width = input && input.offsetWidth;
      var position = isMobile ? width - 23 || 230 - (isRtl ? 0 : -130) : 369;
      var left = position - String(value).length * 10 + 'px';
      return { left: left };
    };var propertyPrice = props.price || 0;_this.state = { priceApartment: propertyPrice, equity: Math.round(propertyPrice / 7) || 0, changeEquity: false, periodInYears: periodInYearsDefault, mortgage: 0, monthlyRepayRepresents: 0, rate: 7 };return _this;}MortgageCalculate.prototype.componentDidMount = function componentDidMount() {this.calculateMortgage();};MortgageCalculate.prototype.

  render = function render() {var
    translate = this.props.translate;
    var ltrSymbol = String.fromCharCode(8206);

    return (
      _react2.default.createElement('div', { className: (0, _classnames2.default)(_MortgageCalculate2.default.mortgageCalculateWrapper) },
        _react2.default.createElement('div', { className: (0, _classnames2.default)(_MortgageCalculate2.default.mortgageCalculateInputWrapper) },
          _react2.default.createElement('div', null,
            _react2.default.createElement('div', { className: (0, _classnames2.default)(_MortgageCalculate2.default.mortgageCalculateInput) },
              _react2.default.createElement(_components.OMFormGroup, {
                label: '' + translate('priceApartment'),
                onChange: this.onChangeApartment,
                value: ltrSymbol + '\u20AA ' + (0, _publish.price)(this.state.priceApartment),
                isAccordion: true,
                readOnly: true,
                onBlur: this.calculateMortgage,
                onKeyDown: this.onKeyDown,
                className: _MortgageCalculate2.default.formGroup,
                classNameLabel: _MortgageCalculate2.default.formGroupLabel })),


            _react2.default.createElement('div', { className: (0, _classnames2.default)(_MortgageCalculate2.default.mortgageCalculateInput) },
              _react2.default.createElement(_components.OMFormGroup, {
                label: '' + translate('equity'),
                onChange: this.onChangeEquity,
                value: ltrSymbol + '\u20AA ' + (0, _publish.price)(this.state.equity),
                onBlur: this.calculateMortgage,
                onKeyDown: this.onKeyDown,
                className: _MortgageCalculate2.default.formGroup,
                classNameLabel: _MortgageCalculate2.default.formGroupLabel,
                isAccordion: true }))),



          _react2.default.createElement('div', null,
            _react2.default.createElement('div', { className: (0, _classnames2.default)(_MortgageCalculate2.default.mortgageCalculateInput) },
              _react2.default.createElement(_components.OMFormGroup, {
                label: '%',
                onChange: this.onChangeRate,
                value: this.state.rate,
                isAccordion: true,
                onBlur: this.calculateMortgage,
                onKeyDown: this.onKeyDown,
                className: _MortgageCalculate2.default.formGroup,
                classNameLabel: _MortgageCalculate2.default.formGroupLabel })),


            _react2.default.createElement('div', { className: (0, _classnames2.default)(_MortgageCalculate2.default.mortgageCalculateInput) },
              _react2.default.createElement(_components.OMFormGroup, {
                label: '' + translate('periodInYears'),
                onChange: this.onChangePeriodInYears,
                value: this.state.periodInYears,
                isAccordion: true,
                onBlur: this.calculateMortgage,
                onKeyDown: this.onKeyDown,
                className: _MortgageCalculate2.default.formGroup,
                classNameLabel: _MortgageCalculate2.default.formGroupLabel })))),




        _react2.default.createElement('div', { className: (0, _classnames2.default)(_MortgageCalculate2.default.mortgageCalculateResultWrapper) },
          _react2.default.createElement('div', null,
            _react2.default.createElement('p', null, translate('mortgage')),
            _react2.default.createElement('span', { className: (0, _classnames2.default)(_MortgageCalculate2.default.bold) }, '\u20AA', (0, _publish.price)(this.state.mortgage))),

          _react2.default.createElement('div', null,
            _react2.default.createElement('p', null, translate('monthlyRepayRepresents')),
            _react2.default.createElement('span', { className: (0, _classnames2.default)(_MortgageCalculate2.default.bold) }, '\u20AA', (0, _publish.price)(this.state.monthlyRepayRepresents))))));




  };return MortgageCalculate;}(_react.Component);exports.default = MortgageCalculate;


MortgageCalculate.propTypes = {
  translate: _propTypes2.default.func,
  price: _propTypes2.default.number,
  isMobile: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/MortgageCalculate/MortgageCalculate.js
// module id = 2709
// module chunks = 0